import { h } from 'preact';

import Modal from '../modal';
import Form from './form';

const Auth = ({ text, className }) => {
  return (
    <Modal>
      {({ isOpen, onOpen, onDialogClick, onClose }) => (
        <>
          <button type="button" onclick={onOpen} class={className}>
            {text}
          </button>

          <div onClick={onClose} class={`modal ${isOpen ? `open` : ``}`}>
            {isOpen ? (
              <div onClick={onDialogClick} class="dialog">
                <button type="button" onClick={onClose} class="modal-close">
                  <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M.3 9.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3L5 6.4l3.3 3.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L6.4 5l3.3-3.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L5 3.6 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4L3.6 5 .3 8.3c-.4.4-.4 1 0 1.4z"
                      fill="#fff"
                      fill-rule="nonzero"
                    />
                  </svg>
                </button>

                <Form onClose={onClose} />

              </div>
            ) : null}
          </div>
        </>
      )}
    </Modal>
  );
};

export default Auth;
